module.exports = __webpack_public_path__ + "static/media/color3@2x.fd541115.png";